import React from 'react';
import { Subscribe } from '@/basic/Subscribe/Subscribe';
import type { II18nPackageRes } from '@/interface/ICommon';
import { ReoPopup } from '@/deps/basic';
import styles from './index.module.less';
import classnames from 'classnames';
export interface ISubscribePopupTexts{
    title?: string;
}

interface IProps{
    subjectKey: string;
    open: boolean;
    onClose?: () => void;
    i18nPackage: II18nPackageRes['i18nPackage'];
    title?: string;
    country: string;
    onSuccess?: () => void;
    btnText?: string;
}

const CompSubscribePopup: React.FC<IProps> = (props) => {

    const handleClose = props.onClose;
    const handleSuccess = props.onSuccess;
    return (
        <ReoPopup
            open={ props.open }
            onClose={ handleClose }
            popupType={ 'form' }
            key={ props.subjectKey }
            className={ classnames(styles['subscribe-popup'], __MERCHANT__ === 'camovue' ? styles['pop_up'] : '') }
            childrenMaxHeight={ 'calc(100vh - 200px)' }
            bodyClassName={ styles['subscribe-popup-body'] }
        >
            <Subscribe
                className={ styles.subscribe }
                subject={ props.subjectKey }
                i18nPackage={ props.i18nPackage }
                commingText={ props.title }
                country={ props.country }
                onSuccess={ handleSuccess }
                inputWidth={ '100%' }
                btnText={ props.btnText }
            />
        </ReoPopup>
    );
};
export default CompSubscribePopup;
